import React, { useEffect, useRef } from "react";
import "./homeCarousel.scss";
import "react-slideshow-image/dist/styles.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import TextLogo from "../../../components/SVG/TextLogo";
import IntroVideoMP4 from "../../../assets/video/intro-video.webm";
// import IntroVideoMP4 from "../../../assets/video/intro-video.";

gsap.registerPlugin(ScrollTrigger);

const HomeCarousel = () => {
  const textRef = useRef();

  // useEffect(() => {
  //   const tl = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: ".homeCarousel", // the whole hero section
  //       start: "top top",
  //       end: "bottom top",
  //       scrub: 1,
  //       // markers: true,
  //     },
  //   });

  //   tl.to(textRef.current, {
  //     scale: 4,
  //     autoAlpha: 0,
  //     ease: "none",
  //   });
  // }, []);

  return (
    <div className="homeCarousel">
      {/* <div className="sticky-center">
        <div ref={textRef} className="brand-name-logo-container">
          <TextLogo className="brand-name-logo" />
        </div>
      </div>
      <div className="trigger-zone"></div> */}
      <video
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={IntroVideoMP4} type="video/mp4" />
        {/* <source src={IntroVideo} type="video/mp4" /> */}
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default HomeCarousel;
